/**
 * Created by afuhr on 30.08.2016.
 */
/**
 * Created by afuhr on 27.05.2016.
 */
import {Injectable} from "@angular/core";
import {Mission} from "../model/mission.type";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {VisbosService} from "../../core/visbos-core/graphql/visbos.service";
import {MissionInput} from "../model/mission-input.type";
import gql from "graphql-tag";
import {Observable} from "rxjs/Observable";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../shared/redux-store";
import {SessionActions} from "../../shared/actions";
import {map} from "rxjs/operators";

export const fragments = {
  mission: gql`
    fragment MissionFields on Mission {
      cuid, label, mission_number, mission_date,
      administration_unit {
        cuid, label
      }
    }
  `
};

export const fetchMissionsQuery = gql`
  query FetchMissionsQuery {
    missions {
      ...MissionFields
    }
  }
  
  ${fragments.mission}
`;

@Injectable()
export class MissionService extends VisbosService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public createMission(missionData: MissionInput): Observable<Mission> {
    let processedMissionData = this.processData(missionData);

    return <Observable<Mission>>this.apollo.mutate({
      mutation: gql`
        mutation CreateMissionMutation($missionData: MissionInput!) {
          createMission(mission: $missionData){
           ...MissionFields 
          }
        }
        
        ${fragments.mission}
      `,
      variables: {
        missionData: processedMissionData
      }
    }).pipe(map(({data}: any) => data.createMission));
  }

  public updateMission(cuid: string, missionData): ApolloQueryObservable<Mission> {
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/mission/services/mission.service.ts